import { motion } from 'framer-motion';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { ImagePreloader } from '../image/ImagePreloader';

interface Props {
  title: string;
  to: string;
  url?: string;
  description?: string;
}

export const PictureLink: FC<Props> = ({ title, to, url, description }) => {
  return (
    <Link to={to} className="h-52 overflow-hidden border rounded-md relative">
      <motion.button className="h-full w-full" whileHover="hover" variants={{ hover: {} }}>
        <motion.div
          variants={{ hover: { scale: 1.1 } }}
          style={{ originX: 0, originY: 1 }}
          className="text-white text-left absolute w-[85%] bottom-2 left-3 z-30"
        >
          <p className="font-semibold text-lg">{title}</p>
          <p className="">{description}</p>
        </motion.div>
        <div className="absolute w-full bottom-0 h-[75%] bg-gradient-to-t from-primary-800 z-20 to-transparent opacity-75"></div>
        <motion.div
          variants={{ hover: { scale: 1.1 } }}
          className="h-full w-full bg-cover bg-center"
          style={{ backgroundImage: `url(${url})` }}
        ></motion.div>
        {url && <ImagePreloader url={url} />}
      </motion.button>
    </Link>
  );
};
